import { render, staticRenderFns } from "./RepaymentGoogleBarChart.vue?vue&type=template&id=72351c7a&"
import script from "./RepaymentGoogleBarChart.vue?vue&type=script&lang=js&"
export * from "./RepaymentGoogleBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports